import React from 'react'
import PropTypes from 'prop-types'
import { ImagePicker } from 'react-file-picker'
import { renderAlert } from '../../services/render-alert'
import css from './styles/PendingMediaMessage.css'

const PendingMediaMessage = ({ mediaBase64Data, previewPendingMedia }) => {

  const mediaBgStyle = { backgroundImage: `url(${mediaBase64Data})` }

  return (
    <div className={css.outerContainer}>
      <div className={css.previewText}>
        Preview
      </div>
      <div
        className={css.image}
        style={mediaBgStyle}
      />
      <div className={css.buttonsContainer}>
        <ImagePicker
          extensions={['jpg', 'jpeg', 'png']}
          dims={{ minWidth: 100, maxWidth: 2000, minHeight: 100, maxHeight: 2000 }}
          onChange={img => previewPendingMedia(img)}
          onError={err => renderAlert(err)}
        >
          <div className={css.button}>
            Change
          </div>
        </ImagePicker>
        <div
          className={css.button}
          onClick={() => previewPendingMedia(null)}
        >
          Remove
        </div>
      </div>
    </div>
  )
}
PendingMediaMessage.propTypes = {
  mediaBase64Data: PropTypes.string.isRequired,
  previewPendingMedia: PropTypes.func.isRequired,
}

export default PendingMediaMessage



// WEBPACK FOOTER //
// ./src/components/Messages/PendingMediaMessage.js